import {
  GET_ALL_INDENODES_SUCCESS,
  DELETE_INDE_NODE_SUCCESS,
  EDIT_INDE_NODE_SUCCESS,
  CREATE_INDE_NODE_SUCCESS,
  UPDATE_DEFAULT_INDENODE_CONTROL_SUCCESS,
  SET_INDENODE_DATA,
  SET_INDENODES_SUCCESS
} from './actions';

const initialState = {
  indeNodes: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_INDENODES_SUCCESS:
    case DELETE_INDE_NODE_SUCCESS:
    case EDIT_INDE_NODE_SUCCESS:
    case SET_INDENODE_DATA:
    case SET_INDENODES_SUCCESS:
    case UPDATE_DEFAULT_INDENODE_CONTROL_SUCCESS:
    case CREATE_INDE_NODE_SUCCESS:
      return {
        ...state,
        indeNodes: action.data
      };
    default:
      return state;
  }
};

export default reducer;
